import React from "react";
import { Link } from "react-router-dom";

interface CourseListProps {
  courses: string[];
  college_name: string;
}

const CourseList: React.FC<CourseListProps> = ({ courses, college_name }) => {
  const visibleCourses = courses.slice(0, 4);
  const remainingCount = courses.length - 4;

  return (
    <>
      {visibleCourses.map((course, index) => (
        <span key={index}>
          {course}
          {index < visibleCourses.length - 1 && <span className="px-1">/</span>}
        </span>
      ))}

      {courses.length > 4 && (
        <Link
          to={`/college-details/${college_name}#courses-&-fees`}
          className="ml-2 text-blue-600 underline text-sm"
        >
          +{remainingCount} more
        </Link>
      )}
    </>
  );
};

export default CourseList;
